module.exports = __webpack_public_path__ + "img/sm_03_twit.f32bb71c.svg";